import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  NgbAccordionModule,
  NgbDatepickerModule,
  NgbTooltipModule,
} from '@ng-bootstrap/ng-bootstrap';
import { UtilSharedModule } from '@aptitude/shared';
import { FormatComboTierSpendLevelPipe } from '@aptitude/shared-vanilla';
import { Angulartics2Module } from 'angulartics2';
import { FormsModule } from '@angular/forms';

@NgModule({
  imports: [
    CommonModule,
    NgbTooltipModule,
    Angulartics2Module.forRoot(),
    FormsModule,
    NgbDatepickerModule,
    NgbAccordionModule,
    UtilSharedModule,
  ],
  exports: [
    NgbTooltipModule,
    NgbDatepickerModule,
    NgbAccordionModule,
    UtilSharedModule,
  ],
  providers: [FormatComboTierSpendLevelPipe],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class UtilModule {}
